import React from 'react'

import { ProductPanel } from '@sainsburys-tech/bolt'

import * as Styled from '../PromotionLink.styles'

export default class PromotionProductPanel extends React.Component {
  render() {
    const { product, isLoading, dataTest, totalNectarPoint } = this.props

    if (isLoading) return <ProductPanel.ProductPanelSkeleton />

    if (!product || !Object.keys(product)?.length) {
      return null
    }

    const { partNumber, name } = product?.data?.attributes || {}

    const price = product?.included?.find(item => item.type === 'prices')?.attributes
    const reviews = product?.included?.find(included => included.type === 'reviewstatistics')?.attributes

    const props = {
      isLoading,
      partNumber,
      name,
      price: price?.now,
      wasPrice: price?.was,
      rating: reviews?.avgRating,
      ratingCount: reviews?.reviewCount,
      lazy: true,
      showBorder: true,
      showThumbnail: true,
      showPartNumber: false,
      linkTitle: true,
      quantity: null
    }

    const children = (
      <Styled.Label>
        <Styled.LabelImage
          src='https://i1.adis.ws/i/Argos/NectarNew'
          width='24'
          height='20'
          data-test='nectar-points-label-image'
        />
        <span data-test={`${dataTest}-nectar-text`}>
          Collect <b> {totalNectarPoint} Nectar </b> points
        </span>
      </Styled.Label>
    )
    return (
      <Styled.ProductPanelWrapper>
        <ProductPanel data-test={`${dataTest}`} {...props} />
        <Styled.DrawerNectarPointsWrapper> {children} </Styled.DrawerNectarPointsWrapper>
      </Styled.ProductPanelWrapper>
    )
  }
}
